import React from 'react';
import { useTheme } from '@material-ui/core';

interface SpaceProps {
    gap: number;
}

const Space: React.FC<SpaceProps> = ({ gap }) => {
    const theme = useTheme();
    return (
        <div
            style={{
                width: '100%',
                height: theme.spacing(gap),
            }}
        />
    );
};

export default React.memo(Space);
